<app-si-dialog modalBodyClasses="p-4 min-h-[200px]" header="Export Companies to Salesforce" (close)="onClose()">
	<ng-template appDialogBody>
		<section class="pt-6" *ngIf="!isExportButton && currentPage === pages.loading && !isBusy">
			<div class="flex justify-center pt-6">
				<mat-spinner></mat-spinner>
			</div>
		</section>

		<section *ngIf="isBusy" class="mt-12 text-center">
			<strong class="block">{{busyLabel}}</strong>
			{{busySublabel}}
		</section>
		<div *ngIf="isExportButton && !isBusy">
			<table class="si-table">
				<thead>
				<tr class="border-bottom-primary">
					<th><span class="pl-6 ml-2">Type of Company</span></th>
					<th class="numeric">Count</th>
					<th class="numeric">Action</th>
				</tr>
				</thead>
				<tbody>
				<tr *ngIf="humanVerifiedCompanies.length > 0">
					<td><span class="export-icon human-verified"
							  [matTooltip]="(humanVerifiedCompanies.length == 1 ? 'This company has' : 'These companies has') + ' been Human Verified by SalesIntel and can be exported with its enriched details.'"
							  matTooltipPosition="right"></span> Human Verified</td>
					<td class="numeric">{{humanVerifiedCompanies.length}}</td>
					<td>Export to Salesforce</td>
				</tr>
				<tr *ngIf="machineVerifiedCompanies.length > 0 ||  unmatchedCompanies.length > 0">
					<td><fa-icon [matTooltip]="((machineVerifiedCompanies.length + unmatchedCompanies.length) == 1 ? 'This company has' : 'These companies has') + ' been Machine Verified by SalesIntel. You may get it verified by a human using our Research on Demand service.'" matTooltipPosition="right" class="mr-2" [icon]="['fas', 'desktop']"></fa-icon>&nbsp;&nbsp;&nbsp;Machine Verified</td>
					<td class="numeric">{{machineVerifiedCompanies.length + unmatchedCompanies.length}}</td>
					<td>Submit to Research on Demand<fa-icon [matTooltip]="'These records will be sent to our team of researchers to validate the information.'" class="ml-2" [icon]="['fas', 'circle-info']"></fa-icon></td>
				</tr>
				</tbody>
			</table>
		</div>
		<section *ngIf="!isExportButton && currentPage === pages.duplicates && !isBusy">
			<h3>Duplicates</h3>
			<div class="flex flex-wrap -mx-2">
				<div class="flex-none w-1/2 px-2">
					<b>Found {{ duplicateCompanyCount }} duplicate<span *ngIf="duplicateCompanyCount != 1">s</span>:</b>
				</div>
				<div class="flex-none w-1/2 label-group px-2">
					<b>Resolve Duplicates by:</b>
				</div>
			</div>
			<div class="flex flex-wrap -mx-2 mt-2">
				<div class="flex-none w-1/2 table-scroll px-2">
					<table class="table-fixed si-table si-table--hover si-table--grid">
						<tbody>
						<tr *ngFor="let match of duplicateCompanyMatchIds ">
							<td class="flex-none w-full px-2">{{ match.company_name }}</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div class="flex-none w-1/2 px-2">
					<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
				</div>
			</div>
		</section>

		<section class="mt-4 pl-4 table-scroll" *ngIf="currentPage === pages.exportFinished && !isBusy">
            <ng-container *ngIf="exportedCompanyCount > 0 && failedCompany.length !== exportedCompanyCount; else companyFailedHeader">
                <h3>Export Succeeded</h3>
            </ng-container>
            <ng-template #companyFailedHeader>
                <h3>Export Failed</h3>
            </ng-template>
			<div class="flex flex-wrap -mx-2">
				<div class="flex-none w-full px-2" *ngIf="failedCompany.length === 0">
					You have successfully exported {{exportedCompanyCount}}
					<span *ngIf="exportedCompanyCount === 1">company </span>
					<span *ngIf="exportedCompanyCount !== 1">companies </span>
					to Salesforce.
				</div>
				<div class="flex-none w-full px-2" *ngIf="failedCompany.length > 0">
					<p>For {{failedCompany.length}} company couldn't be updated. This could be caused
						by the Salesforce DuplicateChecker or because SalesIntel is not allowed to create new Accounts in
						your Salesforce instance.</p>

					<table class="table-fixed si-table si-table--hover">
						<tr *ngFor="let failedComp of failedCompany">
							<td class="flex-none w-full text-danger px-2">
								Failed export <strong>{{failedComp.company_name}}</strong>: {{failedComp.message}}
							</td>
						</tr>
					</table>
				</div>
			</div>
		</section>

		<section class="text-center" *ngIf="currentPage === pages.exportEmpty && !isBusy">
			<h3>Nothing to Export</h3>
			All selected company are duplicates and you decided to skip duplicates, so there's nothing left to export.
		</section>

		<section class="text-center" *ngIf="currentPage === pages.exportFailed && !isBusy">
			<h3>Export Failed</h3>
			Your export failed with the following error:
			<pre class="text-danger" style="max-height: 200px; white-space: pre-wrap;">{{exportError}}</pre><br />
			Please resolve the problem in your Salesforce instance and retry or contact SalesIntel support at <a
				href="mailto:support@salesintel.io">support&#64;salesintel.io</a>.
		</section>
	</ng-template>

	<ng-template appDialogFooter>
		<div>
			<button matButton="outlined" type="button" *ngIf="showCancelButton && !isBusy"
					(click)="onClose()">Cancel</button>
		</div>
		<div>
			<button matButton="filled" type="button" class="ml-2" *ngIf="isExportButton && !isBusy" (click)="exportInboxintel()">
				Export</button>
			<button matButton="outlined" type="button" class="mr-2" *ngIf="showPreviousButton && !isBusy"
					(click)="previous()">Previous</button>
			<button matButton="filled" type="button" *ngIf="showNextButton && !isBusy" (click)="next()">Next</button>
			<button matButton="filled" type="button" *ngIf="showRetryButton" (click)="retryExport()">Retry</button>
			<button matButton="outlined" type="button" *ngIf="showCloseButton" (click)="onClose()">Close</button>
		</div>
	</ng-template>
</app-si-dialog>
